import { render } from "./ProposalsTable.vue?vue&type=template&id=4d2c1915"
import script from "./ProposalsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalsTable.vue?vue&type=script&setup=true&lang=js"

import "./ProposalsTable.vue?vue&type=style&index=0&id=4d2c1915&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/ProposalsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d2c1915"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d2c1915', __exports__)) {
    api.reload('4d2c1915', __exports__)
  }
  
  module.hot.accept("./ProposalsTable.vue?vue&type=template&id=4d2c1915", () => {
    api.rerender('4d2c1915', render)
  })

}


export default __exports__